import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LaasOption } from 'src/app/core/models/laas-option';
import { deepCopy, getDataScopeByPermission, getForwarderByPermission, isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { FacilityService } from 'src/app/core/services/facility.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { DataScope } from 'src/app/core/models/data-scope';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { TruckCostAllocationService } from '../../services/truck-cost-allocation.service';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { addDays, endOfDay, startOfDay } from 'date-fns';
import { SearchCrossBoundryResponse } from 'src/app/core/models/transport-operation/search-crossboundry-response';
import { finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmEventType, MenuItem } from 'primeng/api';
import { CrossBoundryAddressResponse } from 'src/app/core/models/transport-operation/crossboundry-address-response';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { SearchCrossBoundryDetailResponse } from 'src/app/core/models/transport-operation/search-crossboundry-detail-response';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { AddressMaintainanceService } from 'src/app/features/setting/service/address-maintainance.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';
import { ContainerService } from '../../services/container-service.service';


@Component({
  selector: 'laas-truck-cost-allocation',
  templateUrl: './truck-cost-allocation.component.html',
  styleUrl: './truck-cost-allocation.component.scss'
})
export class TruckCostAllocationComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode = PermissionConstants.ViewTruckCostAllocation;
  readonly editPermissionCode = PermissionConstants.EditTruckCostAllocation;

  @ViewChild('headerTable') dataTable!: DataTableComponent;
  @ViewChild('createDt') createDt!: CalendarComponent;

  searchResults: SearchCrossBoundryResponse[] = [];
  searchCreateResults:any[] = [];
  searchDetailResults: SearchCrossBoundryDetailResponse[] = [];
  allAddressResults: CrossBoundryAddressResponse[][] = [];
  addressResults: CrossBoundryAddressResponse[] = [];

  isSearchFormOpen: boolean = true;
  searchForm: FormGroup;
  isLoading: boolean = false;
  columns: any[];
  selectedRows: any[] = [];
  selectedDetailRows: any[] = [];
  searchParams: any;

  isActivatedOptions: any[] = [];
  isFeeCalculationOptions: any[] = [];

  forwarderOptions: any[];
  allForwarderOptions: any[];
  billCorpOptions: any[];
  registrationKeyList: string[] = [];
  editMode: boolean = false;
  vendorSuggests: string[] = [];
  vendorOptions: LaasOption[] = [];
  canEditTable: boolean;
  cloneResult: any[] = [];
  editForwarder: boolean = true;
  carTypeOptions: any[];
  cbTypeOptions: any[];
  cbType: any;
  dataScopes: DataScope[] = [];
  facilityOptions: Array<LaasOption> = [];
  readonly dayRange: number = 30;
  isShowAddressDialog: boolean = false;
  isShowImportDialog: boolean = false;
  crossBoundryNo: string;
  detailColumns: any[];
  CrossBoundryDetails: any[];
  countryOptions: any[];
  cityOptions: any[];
  areaAllOptions: any[];

  isDeatailLoading = false;
  isDialogisLoading = false;
  addressTableColumns: DateTableColumn[]= [];
  isDetailLoading: boolean = false;
  defaultCreateDt: Date[];
  cost = '';
  costReview: any;
  generateCostReport = '';

  //file Management
  isShowBillingViewerModal: boolean = true;
  bookingNoFile: string;
  bookingInfo: any;
  itemMenus: MenuItem[];
  isShowBillingPreviewCalculateViewerModal: boolean;
  bookingNoPreviewCalculate: any;
  previewBillingCbType: any;

  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  sortOrder: SortOrder = {
    property: "createDt",
    direction: -1
  };
  currentLang: string = this.laasSetting.language;

  constructor(private fb: FormBuilder, injector: Injector,
    private truckCostAllocationService: TruckCostAllocationService,
    private facilityService: FacilityService,
    private dropdownOptionsService: DropdownOptionsService,
    private containerService: ContainerService,
    private addressMaintainanceService: AddressMaintainanceService,
    private dropdownOptionService: DropdownOptionsService) {
    super(injector);
    this.defaultCreateDt = [startOfDay(addDays(new Date(), this.dayRange * -1)), endOfDay(new Date())];
    this.canEditTable = false;
    this.isShowBillingViewerModal = false;
    this.bookingNoFile = '';
    this.itemMenus = [];


    this.searchParams = {
      containerCodes: [],
      crossBoundryNos: [],
      referenceKeys: [],
      consolidationNos: [],
      createDtStart: null,
      createDtEnd: null,
      isArrived: null,
      dataScopes:null,
      isFeeCaculation: null,
    }
    this.searchForm = this.fb.group({
      facilityList:[null],
      crossBoundryNos: [null],
      consolidationNos: [null],
      containerCodes: [null],
      shipForwarders: [null],
      customsForwarders: [null],
      createCarTypes: [null],
      isFeeCaculation: null,
      createDtStart: null,
      createDtEnd: null,
      referenceKeys: [null],
      isActivated: [null],
      cbType: [null],
    })
    this.columns = [
      { field: 'crossBoundryNo', header: 'TruckCostAllocation.MainTable.CrossBoundryNo', sort: true },
      { field: 'consolidationNo', header: 'TruckCostAllocation.MainTable.ConsolidationNo', sort: true },
      { field: 'shipForwarder', header: 'TruckCostAllocation.MainTable.ShipForwarder', sort: true },
      { field: 'customsForwarder', header: 'TruckCostAllocation.MainTable.CustomsForwarder', sort: true },
      { field: 'vendorNumber', header: 'TruckCostAllocation.MainTable.VendorNumber', sort: true },
      { field: 'billCorp', header: 'TruckCostAllocation.MainTable.BillCorp', sort: true },
      { field: 'cbType', header: 'TruckCostAllocation.MainTable.CbType', sort: true },
      { field: 'createCarType', header: 'TruckCostAllocation.MainTable.CreateCarType', sort: true },
      { field: 'cartonCnt', header: 'TruckCostAllocation.MainTable.CartonCnt', sort: true },
      { field: 'totalGrossWeight', header: 'TruckCostAllocation.MainTable.TotalGrossWeight', sort: true },
      { field: 'totalVolumeWeight', header: 'TruckCostAllocation.MainTable.TotalVolumeWeight', sort: true },
      { field: 'totalPrice', header: 'TruckCostAllocation.MainTable.TotalPrice', sort: true },
      { field: 'isFeeCaculation', header: 'TruckCostAllocation.MainTable.IsFeeCaculation', sort: true },
      { field: 'isActivated', header: 'TruckCostAllocation.MainTable.IsActivated', sort: true },
      { field: 'facility', header: 'TruckCostAllocation.MainTable.Facility', sort: true },
      { field: 'fromCountry', header: 'TruckCostAllocation.MainTable.FromCountry', sort: true },
      { field: 'fromCity', header: 'TruckCostAllocation.MainTable.FromCity', sort: true },
      { field: 'fromArea', header: 'TruckCostAllocation.MainTable.FromArea', sort: true },
      { field: 'toCountry', header: 'TruckCostAllocation.MainTable.ToCountry', sort: true },
      { field: 'toCity', header: 'TruckCostAllocation.MainTable.ToCity', sort: true },
      { field: 'toArea', header: 'TruckCostAllocation.MainTable.ToArea', sort: true },
      { field: 'containerCode', header: 'TruckCostAllocation.MainTable.ContainerCode', sort: true },
    ]
    this.detailColumns  = [
      { field: 'containerCode', header: 'TruckCostAllocation.SubTable.ContainerCode', sort: false },
      { field: 'referenceType', header: 'TruckCostAllocation.SubTable.ReferenceType', sort: false },
      { field: 'referenceKey', header: 'TruckCostAllocation.SubTable.ReferenceKey', sort: false },
      { field: 'createUser', header: 'TruckCostAllocation.SubTable.CreateUser', sort: false },
      { field: 'createDt', header: 'TruckCostAllocation.SubTable.CreateDt', sort: false },
      { field: 'updateUser', header: 'TruckCostAllocation.SubTable.UpdateUser', sort: false },
      { field: 'updateDt', header: 'TruckCostAllocation.SubTable.UpdateDt', sort: false }
    ];
    this.addressTableColumns = [
      { field: 'pickupLocationAddress', header: 'TruckCostAllocation.AddressDialog.PickupLocationAddress' },
      { field: 'country', header: 'TruckCostAllocation.AddressDialog.Country' },
      { field: 'city', header: 'TruckCostAllocation.AddressDialog.City' },
      { field: 'assignDistrictId', header: 'TruckCostAllocation.AddressDialog.AssignmentDistrictId' },
    ];

    this.cbTypeOptions = [
      { label: '1.出貨', value: 1 },
      { label: '2.進貨', value: 2 },
      { label: '3.報關', value: 3 },
      { label: '4.出貨+報關', value: 4 },
      { label: '5.進貨+報關', value: 5 },
      { label: '6.本地', value: 6 }
    ];

    this.crossBoundryNo = '';
    this.CrossBoundryDetails = [];
    this.billCorpOptions = [];
    this.carTypeOptions = [];
    this.forwarderOptions = [];
    this.allForwarderOptions = [];
    this.countryOptions = [];
    this.cityOptions = [];
    this.areaAllOptions = [];

    this.isFeeCalculationOptions = [];
    this.isShowBillingPreviewCalculateViewerModal = false;
  }
  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.forwarderOptions = options.filter((x: any) => {
          return ( this.userProfile.userType === UserType.SuperAdmin.toString() ||
          this.userProfile.userType === UserType.Shipping.toString() ||
          getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });

    this.dropdownOptionsService.getAllForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.allForwarderOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });


    this.containerService.getCarTypeByAllFacility().subscribe({

      next: (result) => {
        this.carTypeOptions = [...result].map((x: any) => {
          console.log('我有近來getCarTypeByAllFacility');
          return {
            label: `${x.carType} - ${x.carCnDesc}`,
            value: x.carType
          };
        });
      },
    });

    this.dropdownOptionsService.getLetterOrgOptions().subscribe({
      next: (result: any[]) => {
        this.billCorpOptions = result
          .filter((x) => x.billOUCode !== null)
          .reduce((options, item) => {
            if (
              options.findIndex((x: any) => x.value === item.billOUCode) < 0
            ) {
              options.push({ label: item.billOUName, value: item.billOUCode });
            }
            return options;
          }, [])
          .sort((a: any, b: any) => {
            return a.value > b.value ? 1 : -1;
          });
      },
    });



    this.dropdownOptionService.getIsFeeCalculationOptions().subscribe({
      next: (options: any[]) => {
        this.isFeeCalculationOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getCBStatusOptions().subscribe({
      next: (options: any[]) => {
        this.isActivatedOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.canEditTable = this.permissionCodes.includes(this.editPermissionCode);
    //貨代不能編輯貨代欄位
    if (this.userProfile.userType === UserType.Forwarder.toString()) {
      this.editForwarder = false;
    }
    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: FacilityOptions[]) => {
        this.facilityOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.facilityService.getCountryOptions().subscribe({
      next: result => {
        this.countryOptions = [...result].map((x: any) => {
          return {
            label: `${x.countryCode}-${x.countryName}`,
            value: x.countryCode,
          };
        });
      }
    });

    this.facilityService.getCityOptions().subscribe({
      next: result => {
        this.cityOptions = [...result].map((x: any) => {
          return {
            label: `${x.name}-${x.enName}`,
            value: x.seqNo.toString(),
            country: x.country
          };
        });
      }
    });

    this.dropdownOptionsService.getAllAreaOptionForHK().subscribe({
      next: result => {
        this.areaAllOptions = [...result].filter((x: any) => x.rfqAreaName && x.rfqAreaCode).map((x: any) => {
          return {
            label: x.rfqAreaName,
            value: x.rfqAreaCode,
            citySeqNo : x.citySeqNo,
          };
        });
      }
    });

    this.translateService.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();

  }

  translationLabel() {
    //Container Check Description
    this.cost = this.translateService.instant('ReceiptForm.Button.Cost')
    this.costReview = this.translateService.instant('ReceiptForm.Button.CostReview')
    this.generateCostReport = this.translateService.instant('ReceiptForm.Button.GenerateCostReport')

  }

  searchBtnClick() {
    this.dataTable.cancelRowEdit();
    this.dataTable.isInEditMode = false;
    this.dataTable.setCurrentPage(0);
    this.searchResult();
  }

  searchResult() {
    if (!this.checkSearchParamsVaildity()) {
      return;
    }
    const params = deepCopy(this.searchForm.value);
    console.log('params: ' + JSON.stringify(this.searchForm.value));
    params.pageIndex = this.pageInfo.pageIndex;
    params.pageSize = this.pageInfo.pageSize;
    params.sortOrder = this.sortOrder;
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);
    this.isLoading = true;
    this.truckCostAllocationService.searchCrossBoundry(params)
    .pipe(finalize(() => this.isLoading = false))
    .subscribe({
      next: (response) => {
        response.content.forEach((x: any) => {
          x.crossBoundryDetails = [];
        });
        this.searchResults = response.content;
        // Change page Info
        this.pageInfo.totalRecords = response.totalElements;
        this.pageInfo.totalPages = this.pageInfo.totalRecords / this.pageInfo.pageSize;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
      },
      error: (err: HttpErrorResponse) => {
        this.pageInfo.totalRecords = 0;
        this.pageInfo.totalPages = 0;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
        this.toastErrorMessage(err.error);
      },
    });


    this.itemMenus = [
      {
        label: this.cost,
        items: [
          {
            label: this.costReview,
            command: (event: any) => {
              const rowData = this.dataTable.selectedRow;
              this.openBillingViewerBtn(event, rowData);
            },
            visible: this.permissionCodes.includes(PermissionConstants.BtnBillingDisplay)
          },
          {
            label: this.generateCostReport,
            command: (event: any) => {
              const rowData = this.dataTable.selectedRow;
              this.openBillingPreviewCalculateBtn(event, rowData);
            },
            visible: this.permissionCodes.includes(PermissionConstants.BtnWarehousingQuotation)
          }
        ]
      }
    ];
    this.itemMenus.forEach(x => {
      if (x.items?.every(y => y.visible === false)) {
        x.visible = false;
      }
    });
  }

  searchDetailClick(event: any): void {
    const rowData = event.rowData;
    const isClosed = event.expanded;

    if (isClosed) {
      return;
    }

    const seqNo = rowData.seqNo;
    console.log("this.seqNo ====="+ seqNo);
    this.isDeatailLoading = true;
    this.truckCostAllocationService
      .getCrossBoundryDetail(seqNo)
      .subscribe({
        next: (result) => {
          this.searchDetailResults = result.searchCrossBoundryDetailList;
          this.isDeatailLoading = false;
        },
        error: (err: HttpErrorResponse) => {
          this.toastErrorMessage(err.error);
        },
      });
  }

  resetBtnClick(event: any) {
    this.searchForm.reset();
    this.createDt.ngOnInit();
  }

  cancelCrossBoundry(event: any) {
    let SeqNos = this.selectedRows.map(x => x.seqNo);
    if (SeqNos != null && SeqNos.length > 0){
      this.confirmationService.confirm({
        message: this.translateService.instant('請問是否確定取消此CB號?'),
        header: this.translateService.instant('系統資訊'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.isLoading = true;
          this.truckCostAllocationService.cancelCrossBoundry(SeqNos)
          .subscribe({
            next: result => {
              this.toastService.success('資料成功取消!!');
              this.isLoading = false;
              this.searchBtnClick();
            },
            error: err => {
              this.isLoading = false;
              this.toastErrorMessage(err.error);
            },
            complete: () => {
              this.logger.info('complete...');
              this.loader.hide();
              this.isLoading = false;
            }
          });
        },
        reject: (type: any) => {
          this.isLoading = false;
          switch (type) {
            case ConfirmEventType.REJECT:
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        }
      });
    }
  }
  saveData(savedDataBean: DataTableSavedBean): void {
    this.isLoading = false;
    const saveDataRequest = {
      updateList: savedDataBean.updatedList
    };
    console.log("saveDataRequest"+saveDataRequest);
    this.isLoading = true;
    this.truckCostAllocationService.updateCrossBoundry(saveDataRequest).subscribe({
      next: () => {
        this.dataTable.saveSuccessEvent();
        this.searchBtnClick();
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
      },
      error: (error: HttpErrorResponse) => {
        if (error.error.errorMsg) {
          this.toastErrorMessage(error.error.errorMsg);
        } else {
          this.toastErrorMessage(error.error);
        }
      },
    });
  }

  /**
   * chips add event.
   *
   * @param event p-chips onAdd event.
   * @param param
   */
  chipsAdd(event: any, param: string): void {
    const value: string = event.value;

    console.log("原始貼上內容：", JSON.stringify(value));

    const parsedValues: string[] = value
      .split(/\r?\n/)
      .map((x) => x.trim())  // 去除每一行開頭和結尾的空白字元（包括 tab、空格、換行）
      .map((x) => x.replace(/\s+/g, '')) // 去除每行內的多餘空白字元
      .filter((x) => x.length > 0);  // 過濾掉空字串

    this.searchParams[param].splice(this.searchParams[param].indexOf(0));
    this.searchParams[param] = this.searchParams[param].concat(parsedValues);
  }

  dateOnChange(date: any, type: string) {
    if (type === 'createDt') {
      this.searchForm.controls.createDtStart.setValue(date.startDate);
      this.searchForm.controls.createDtEnd.setValue(date.endDate);
      this.searchParams.createDtStart = date.startDate;
      this.searchParams.createDtEnd = date.endDate;
    }
  }

  switchEditMode() {
    this.editMode = !this.editMode;
    console.log(this.editMode);
  }

  dataInputValid(rowData: SearchCrossBoundryResponse): boolean {
    if (rowData) {
      if (isNullOrEmpty(rowData.vendorNumber) || isNullOrEmpty(rowData.billCorp) || isNullOrEmpty(rowData.createCarType)) {
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
        return false;
      }
    }
    return true;
  }

  checkSearchParamsVaildity(): boolean {
    return true;
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBtnClick();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.dataTable.setCurrentPage(0);
    this.searchBtnClick();
  }

  openAddressDialog(event: any): void {
    this.isShowAddressDialog =  true;
    this.isDialogisLoading = true;
    let seqNos = this.selectedRows.map(x => x.seqNo);
    this.truckCostAllocationService.queryCrossBoundryAddressInfo(seqNos)
    .pipe(finalize(() => this.isDialogisLoading = false))
    .subscribe({
      next: (response) => {
        this.allAddressResults = response;
        console.log("allAddressResults ====" +  this.allAddressResults);
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
      },
    });
  }

  openImportDialog(event: any): void {
    this.isShowImportDialog =  true;
  }

  formatTableTitle(rowData: any): string {
    return `CrossBoundryDetail - ${rowData.crossBoundryNo}`;
  }

  closeDialog(event: any): void {
    this.isShowAddressDialog = false;  // 關閉對話框
    this.addressResults = [];  // 清空 addressResults
  }

  onDialogClose() {
    this.searchCreateResults = [];  // 清空查詢結果
    this.isShowImportDialog = false;
  }

  closeImportCrossBoundryEvent(event: any): void {
    this.onDialogClose();
    this.searchBtnClick();
  }

  isFeeCalculation(rowData: any): boolean {
    if (rowData) {
      if (isNullOrEmpty(rowData.isFeeCaculation)) {
        return false;
      }  else if ('Y' === rowData.isFeeCaculation) {
        return false;
      }
    }
    return true;
  }

  closeBilling(display: boolean): void {
    this.isShowBillingViewerModal = display;
  }


  openBillingPreviewCalculateBtn(event: any, rowData: any): void {
    this.isShowBillingPreviewCalculateViewerModal = true;
    this.bookingNoPreviewCalculate = rowData.crossBoundryNo;
    this.previewBillingCbType = rowData.cbType;
  }

  closeBillingPreviewCalculate(display: boolean): void {
    this.isShowBillingPreviewCalculateViewerModal = false;
  }

  async openBillingViewerBtn(event: any, rowData: any): Promise<void> {
    this.bookingNoFile = rowData.crossBoundryNo;
    console.log("rowData.crossBoundryNo "+rowData.crossBoundryNo);
    this.bookingInfo =  await this.truckCostAllocationService.searchCrossBoundryByCBNo(rowData.crossBoundryNo);
    console.log("this.bookingInfo "+this.bookingInfo );

    this.isShowBillingViewerModal = true;

  }
}



